import React from 'react';
import { PropTypes } from 'prop-types';
import { Col, Row } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import CardTemplate from './CardTemplate';
import ProgressTemplate from './ProgressTemplate';
import { PortalContainer, StyledAlert } from '../../styles/common';

const ProgressContainer = styled.div`
    text-align: left;
`;

const Loader = ({ title, loadingMsg, isDone }) => {
    const { t } = useTranslation();
    return (
        <CardTemplate title={title}>
            <PortalContainer>
                <Row>
                    <Col sm="12">
                        <ProgressContainer>
                            <StyledAlert color="info">
                                {loadingMsg || t('loadingDefault')}
                            </StyledAlert>
                            <ProgressTemplate isFake isDone={isDone} />
                        </ProgressContainer>
                    </Col>
                </Row>
            </PortalContainer>
        </CardTemplate>
    );
};

Loader.propTypes = {
    title: PropTypes.string,
    loadingMsg: PropTypes.func,
};

Loader.defaultProps = {
    title: '',
    loadingMsg: null,
};

export default Loader;
